import { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { verifyCp } from '../driverSlice';

export const useZipCodeField = () => {
  const dispatch = useDispatch();
  const formValues = useSelector((state) => state.driver.formValues);
  const validValues = useSelector((state) => state.driver.validValues);
  
  const [touched, setTouched] = useState(false);

  const value = formValues.codigoPostal || '';

  const validateZipCodeField = useCallback(async (zipCode) => {
    if (zipCode.length === 5) {
      const result = await dispatch(verifyCp({ zipCode }));
      if (result.payload?.isValid !== undefined) {
        dispatch({ 
          type: 'driver/setValidValue', 
          payload: { field: "codigoPostal", isValid: result.payload.isValid } 
        });
      } else {
        dispatch({ 
          type: 'driver/setValidValue', 
          payload: { field: "codigoPostal", isValid: false } 
        });
      }
    }
  }, [dispatch]);

  const handleKeyDown = useCallback((e) => {
    const allowedKeys = [
      'Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 
      'Home', 'End', 'Enter'
    ];
    
    if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
      return;
    }
    
    const currentValue = formValues.codigoPostal || '';
    if (currentValue.length >= 5 && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  }, [formValues.codigoPostal]);

  const handleChange = useCallback((e) => {
    const { value } = e.target;    
    const numericValue = value.replace(/\D/g, '').slice(0, 5);
    
    dispatch({ 
      type: 'driver/setFormValue', 
      payload: { field: "codigoPostal", value: numericValue } 
    });

    if (numericValue.length === 5) {
      validateZipCodeField(numericValue);
    } else {
      dispatch({ 
        type: 'driver/setValidValue', 
        payload: { field: "codigoPostal", isValid: false } 
      });
    }
  }, [dispatch, validateZipCodeField]);

  const handleBlur = useCallback((e) => {
    const { value } = e.target;
    setTouched(true);
    
    if (value.length === 5) {
      validateZipCodeField(value);
    } else if (value && value.length > 0) {
      dispatch({ 
        type: 'driver/setValidValue', 
        payload: { field: "codigoPostal", isValid: false } 
      });
    }
  }, [dispatch, validateZipCodeField]);

  const getErrorMessage = useCallback(() => {
    if (!value && touched) {
      return "El código postal es requerido";
    }
    return '';
  }, [value, touched]);

  const isInvalid = useCallback(() => {
    if (!value && touched) {
      return true;
    }
    if (value.length > 0 && !validValues.codigoPostal) {
      return true;
    }
    return false;
  }, [value, touched, validValues.codigoPostal]);

  return {
    value,
    handlers: {
      onChange: handleChange,
      onBlur: handleBlur,
      onKeyDown: handleKeyDown
    },
    getErrorMessage,
    isInvalid: isInvalid()
  };
};